document.addEventListener('change', function(e) {

  // Only target variant radios
  if (!e.target.classList.contains('single-option-selector__radio')) return;

  console.log('Radio clicked');

  var container = document.querySelector('#quick-view-body');
  if (!container) return;

  var jsonEl = container.querySelector('.product-json');
  if (!jsonEl) {
    console.log('No product JSON');
    return;
  }

  var productData = JSON.parse(jsonEl.textContent);

  // Get selected options
  var selectedOptions = [];

  container.querySelectorAll('.single-option-radio').forEach(function(group) {
    var checked = group.querySelector('input:checked');
    if (checked) selectedOptions.push(checked.value);
  });

  console.log('Selected:', selectedOptions);

  // Find variant
  var matchedVariant = productData.variants.find(function(variant) {
    return variant.options.every(function(opt, i) {
      return opt === selectedOptions[i];
    });
  });

  console.log('Matched:', matchedVariant);

  if (matchedVariant) {

    console.log('Final Variant ID:', matchedVariant.id);

    // 🔥 Update hidden select
    var select = container.querySelector('[name="id"]');
    if (select) {
      select.value = matchedVariant.id;
    }

    // 🔥 UPDATE IMAGE
    // 🔥 UPDATE IMAGE (with fallback)
// 🔥 UPDATE IMAGE (with fallback) + SCROLL
var image = container.querySelector('img.product-single__media');

if (image) {

  if (matchedVariant.featured_image) {

    // 1. Change main image
    image.src = matchedVariant.featured_image.src;

    // 2. Scroll to correct image
    var mediaId = matchedVariant.featured_image.id;

    var targetImage = container.querySelector('[data-media-id="' + mediaId + '"]');

    if (targetImage) {
      // 🔥 FORCE SCROLL INSIDE MODAL
var scrollContainer = container; // this is #quick-view-body

scrollContainer.scrollTo({
  top: targetImage.offsetTop - 100,
  behavior: 'smooth'
});
    } else {
      console.log('Matching image not found');
    }

  } else {

    // fallback to main product image
    var mainImage = productData.featured_image;
    if (mainImage) {
      image.src = mainImage;
    }

  }

}

    // 🔥 UPDATE PRICE
var priceEl = container.querySelector('#ProductPrice');

if (priceEl && window.shopMoneyFormat) {

  function formatMoney(cents, format) {
    var number = cents / 100;

    var withDecimals = number.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    var noDecimals = Math.round(number).toLocaleString('en-US');

    return format
      .replace(/\{\{\s*amount\s*\}\}/gi, withDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/gi, withDecimals)
      .replace(/\{\{\s*amount_with_currency\s*\}\}/gi, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, noDecimals);
  }

  priceEl.innerHTML = formatMoney(
    matchedVariant.price,
    window.shopMoneyFormat
  );
}

// Sold out
var addToCartBtn = container.querySelector('[type="submit"]');

if (addToCartBtn) {
  if (matchedVariant.available) {
    addToCartBtn.disabled = false;
    addToCartBtn.innerText = 'Add to Cart';
  } else {
    addToCartBtn.disabled = true;
    addToCartBtn.innerText = 'Sold Out';
  }
}


    // 🔥 UPDATE SKU
    var skuEl = container.querySelector('.variant-sku');
    if (skuEl) {
      skuEl.textContent = matchedVariant.sku;
    }

  }

});